import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import useDraftsDataHomeDraftsQuery, {
	type useDraftsDataHomeDraftsQuery$data,
	type useDraftsDataHomeDraftsQuery$variables,
} from './__generated__/useDraftsDataHomeDraftsQuery.graphql';
import { DRAFTS_QUERY_OPTIONS } from './draftsQueryHelpers';

export const preloadDrafts = ({ isLoggedIn }) => {
	return waitForAllReturnWhenError([
		query<useDraftsDataHomeDraftsQuery$data, useDraftsDataHomeDraftsQuery$variables>({
			query: useDraftsDataHomeDraftsQuery,
			variables: DRAFTS_QUERY_OPTIONS.variables,
		}),
		preloadOptions({ isLoggedIn }),
	]);
};
